import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppConfig  from '../../app_config/appConfig';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const restProps = { ...rest };
  const authStore = useSelector(state => state.authenticationData);

  return (
    <Route
      path={restProps.path}
      exact={restProps.exact}
      key={restProps.key}
      render={props =>
        authStore.isAuthenticated ? (
          <Component />
        ) : (
          <Redirect to={{ pathname: AppConfig.routePaths.login, state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
